export class SecretManagerServiceClient {
  async accessSecretVersion() {
    return null
  }
}
